module.exports = __webpack_public_path__ + "img/trip-icon_tareas.170f24fc.svg";